// src/pages/pengamatan/buah-alami/detail-tabs/ProsentaseTableHeader.jsx
import React from 'react';
import {
    TableHead,
    TableRow,
    TableCell,
} from '@mui/material';

const ProsentaseTableHeader = () => {
    return (
        <TableHead>
            <TableRow>
                {/* Plot */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={3}>
                    Plot
                </TableCell>
                
                {/* Luas */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={3}>
                    Luas
                </TableCell>
                
                {/* PJP */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={3}>
                    PJP
                </TableCell>
                
                {/* Fase Bunga - Header Utama */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0', textAlign: 'center'}} colSpan={16}>
                    Fase Bunga
                </TableCell>
                
                {/* Tanaman - Header Utama */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0', textAlign: 'center'}} colSpan={4}>
                    Tanaman
                </TableCell>

                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={3}>Buah Alami</TableCell>
                
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={3}>Mati</TableCell>

                {/* Bunga Pinggiran - Header Utama */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} colSpan={2}>Bunga Pinggiran</TableCell>
            </TableRow>
            
            {/* Sub-header untuk Fase Bunga, Tanaman, dan Header Baru */}
            <TableRow>
                {/* Sub-header Fase Bunga */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Open Heart</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Red Bud 1.25</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Red Bud 2.54</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Early Cones</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Mid Cones</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Late Cones</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Early Petals</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Mid Petals</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Late Petals</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Dry Petals</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Filling Stage 1</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Filling Stage 2</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>SC0</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>SC0&gt;</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={2}>Terpetik</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={2}>Dimakan Tikus</TableCell>
                
                {/* Sub-header Tanaman */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={2}>Normal</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} colSpan={2}>Penyakit</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={2}>Kerdil</TableCell>

                {/* Sub-header Bunga Pinggiran */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={2}>Normal</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={2}>Alami</TableCell>

            </TableRow>
            
            {/* Sub-sub-header untuk Penyakit */}
            <TableRow>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(36-37)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(39-40)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(42-44)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(46-48)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(51-53)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(54-56)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(57-58)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(60-62)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(64-65)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(67-72)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(73-105)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(106-125)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(126-130)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px'  }}>(&gt;130)</TableCell>
                
                {/* Sub-sub-header untuk Penyakit Tanaman */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Phy</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Erw</TableCell>

            </TableRow>
        </TableHead>
    );
};

export default ProsentaseTableHeader;